import type { DynamicRouteData, RouterFetchData } from '@wix/thunderbolt-symbols'

export type LightboxEvent = 'popupOpen' | 'popupClose' | 'popupScroll'
// Plain data only: close handlers from the platform worker are Comlink proxies, and a function here can't be cloned
export type LightboxCloseEvent = {
	isReplacedByAnotherLightbox?: boolean
}
// On a swap, a close handler returns this to be notified again when the replacement lightbox closes
export const DEFER_TO_REPLACEMENT = 'deferToReplacement'
export type LightboxEventListener =
	| ((evt?: any, closeEvent?: LightboxCloseEvent) => void | typeof DEFER_TO_REPLACEMENT)
	| null
	| undefined
export type LightboxViewerContext = any
export interface ILightbox {
	open(
		lightboxPageId: string,
		closeHandler?: LightboxEventListener,
		lightboxViewerContext?: LightboxViewerContext,
		dynamicPageIdOverride?: string
	): Promise<void>
	close(options?: CloseLightboxOptions): Promise<void>
	getContext(lightboxPageId?: string): LightboxViewerContext
	isLightbox(pageId: string): boolean
	registerToLightboxEvent(eventType: LightboxEvent, eventHandler: LightboxEventListener): void
	getCurrentLightboxId(): string | undefined
	isOpen(): boolean
}

export interface ICurrentLightbox {
	isDuringReopen(): boolean
}

export interface ILightboxUtils {
	isLightbox(pageId: string): boolean
	getCurrentLightboxId(): string | undefined
	getLightboxPages(): LightboxesMasterPageConfig['popupPages']
	getLightboxRouteData(): DynamicRouteData | undefined
}

export interface ILightboxesPageNavigationHandler {
	name: string
	appWillLoadPage(): void
}

export type CloseLightboxOptions = { deferRemovalUntilNavigationEnd?: boolean }

export type LightboxFeatureState = {
	pageWillLoadHandler: null | Function
	currentLightboxId: string | undefined
	pendingLightboxId: string | undefined
	pendingLightboxPromise?: Promise<void>
	lightboxRouteData?: DynamicRouteData
	lightboxPendingRemoval?: string
}

export type LightboxesMasterPageConfig = {
	popupPages: {
		[pageId: string]: boolean
	}
	isResponsive: boolean
}

export type LightboxPageConfig = {
	closeSiteButtons: {
		[pageId: string]: boolean
	}
	popupsWithCloseOnOverlayClick: {
		[pageId: string]: boolean
	}
}

export interface ILightboxesAPI {
	addLightboxToDynamicStructure: (lightboxPageId: string, focusTriggerOnClose?: HTMLElement | null) => Promise<void>
	removeLightboxFromDynamicStructure: (lightboxPageId: string) => void
}

export interface ILightboxesResponseHandler {
	handleResponse(routerResponsePromise: Promise<Response>): Promise<{
		pageId: string | null
	}>
}

export type PrefixToRouterFetchData = {
	[prefix: string]: RouterFetchData
}

export type LightboxSiteConfig = {
	pageIdToPrefix: Record<string, string>
	prefixToRouterFetchData: PrefixToRouterFetchData
	isBuilderComponentModel: boolean
}
